import type { CompaniesFilterParamsApi } from '@/modules/companies/types';

export const companiesQueryKeys = {
  all: ['companies'] as const,
  list: (filters?: CompaniesFilterParamsApi) =>
    filters
      ? ([...companiesQueryKeys.all, 'list', filters] as const)
      : ([...companiesQueryKeys.all, 'list'] as const),
  detail: (id: string) => [...companiesQueryKeys.all, id] as const,
  stats: (id: string | undefined, range: { from: string; to: string }) =>
    [...companiesQueryKeys.all, id, 'stats', range.from, range.to] as const,
  inbound: (id: string) => [...companiesQueryKeys.all, id, 'inbound'] as const,
  profileLookup: (id: string) =>
    [...companiesQueryKeys.all, id, 'profile', 'lookup'] as const,
  industries: () => [...companiesQueryKeys.all, 'industries'] as const,
  currentTenant: () =>
    [...companiesQueryKeys.all, 'current', 'tenant'] as const,
  notes: (companyId: string) =>
    [...companiesQueryKeys.all, companyId, 'notes'] as const,
  note: (companyId: string, noteId: string) =>
    [...companiesQueryKeys.all, companyId, 'notes', noteId] as const,
};
